import React from "react";

const variantStyles = {
  danger:  { bg: "#fdecea", border: "#f5c6cb", color: "#7b1010", icon: "✕" },
  warning: { bg: "#fff8e1", border: "#ffeeba", color: "#7d5a00", icon: "⚠" },
  success: { bg: "#e8f5ee", border: "#c3e6cb", color: "#1a5c35", icon: "✓" },
  info:    { bg: "#e8f4fd", border: "#bee5eb", color: "#0c5460", icon: "ℹ" },
};

function ModalAlert({ variant = "danger", message, resetCallback, size }) {
  const s = variantStyles[variant] || variantStyles.danger;
  return (
    <>
      <div
        style={{
          position: "fixed", inset: 0,
          backgroundColor: "rgba(0,0,0,0.35)",
          zIndex: 9998,
        }}
        onClick={() => resetCallback(false)}
      />
      <div
        style={{
          position: "fixed",
          top: "50%", left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
          background: s.bg,
          border: `1px solid ${s.border}`,
          borderRadius: 10,
          padding: "20px 24px",
          minWidth: 300,
          maxWidth: size === "lg" ? 520 : 400,
          width: "90%",
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
          color: s.color,
          fontSize: "0.95rem",
          lineHeight: 1.5,
          display: "flex",
          alignItems: "flex-start",
          gap: 12,
        }}
      >
        <span style={{ fontSize: "1.1rem", flexShrink: 0, marginTop: 1 }}>{s.icon}</span>
        <span style={{ flex: 1 }}>{message}</span>
        <button
          onClick={() => resetCallback(false)}
          style={{
            background: "none", border: "none", cursor: "pointer",
            fontSize: "1rem", color: s.color, flexShrink: 0,
            padding: 0, lineHeight: 1, marginTop: 1,
          }}
        >
          ✕
        </button>
      </div>
    </>
  );
}

export default ModalAlert;
